import { ClientPaymentAccountConstants as Constants } from '../types'

const initialState = {
    paymentAccounts: [],
};

export function clientPaymentAccountReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.GET:
            return {
                ...state,
                paymentAccounts: action?.payload?.data,
            };
        
        case Constants.CREDIT:
            return {
                ...state,
            };
            
        case Constants.FAIL:
            return {
                ...state,
                error: action?.error
            }

        case Constants.LOADING:
            return {
                ...state,
                error: null
            }

        case Constants.CLEAR:
            return {
                ...state,
                paymentAccounts: []
            }

        default:
            return state
    }
}